import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    batchTypes: [],
    formDefaults: []
};

const getters = {
    getBatchTypes: (state) => state.batchTypes,
    getFormDefaults: (state) => state.formDefaults
};

const actions = {
    async getImportFormDefaultValues( context, data ) {
        await axios.post(`${backendUrl()}/getImportFormDefaultValues`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            if(response.data.defaultValues) {
                context.commit('setFormDefaults', response.data.defaultValues)
            }
        })
    },

    async importDataFile( context, data ) {
        await axios.post(`${backendUrl()}/importDataFile`, data,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': "bearer " +  vuecookie.get('token')
            }
        }).then(response => {
            this.dispatch('handleResponse', response)
        })
    },

    async getImportBatchTypes( context, data ) {
        await axios.post(`${backendUrl()}/getImportBatchTypes`, null,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setBatchTypes', response.data)
        })
    }
};

const mutations = {
    setBatchTypes: (state, batchTypes) => (state.batchTypes = batchTypes),
    setFormDefaults: (state, defaults) => (state.formDefaults = defaults)
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
